// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditHome/OpengraphResult.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditHome/OpengraphResult.tsx");
  import.meta.hot.lastModified = "1732036225889.4082";
}
// REMIX HMR END

import { Fragment, useMemo } from "react";
import { resultMapping } from "../DocTahedroidImage";
import Button from "~/components/Button";
import InlineOpengraphResult from "../Opengraph/InlineOpengraphResult";
import { useSearchParams } from "@remix-run/react";
import AuditShare from "../AuditShare";
import Heading from "~/components/Heading";
export default function OpengraphResult({
  audit: {
    opengraph,
    reportId
  }
}) {
  _s();
  const [searchParams, setSearchParams] = useSearchParams();
  const opengraphEntries = Object.entries(opengraph).filter(([name]) => name !== "opengraph");
  const opengraphPassing = opengraphEntries.filter(([_, card]) => card.audit.pass);
  const result = useMemo(() => {
    if (opengraphPassing.length <= 2) {
      return "urgent";
    }
    if (opengraphPassing.length <= 4) {
      return "boost";
    }
    if (opengraphPassing.length === opengraphEntries.length) {
      return "approval";
    }
    return "default";
  }, []);
  const {
    opengraph: {
      title,
      message
    },
    diagnosisColor
  } = resultMapping[result];
  return <Fragment>
      <Heading tag="h2">{title}</Heading>
      <InlineOpengraphResult facebook={opengraph.facebook.audit.pass} google={opengraph.google.audit.pass} linkedin={opengraph.linkedin.audit.pass} slack={opengraph.slack.audit.pass} twitter={opengraph.twitter.audit.pass} />
      <p className="text-neutral-600 mb-4">
        <strong className="font-semibold">Diagnosis</strong>:{" "}
        <span className={`font-semibold ${diagnosisColor}`}>
          {opengraphPassing.length}/{opengraphEntries.length} Meta Tags looking
          alright.
        </span>
        <br />
        {message}
      </p>
      {result === "approval" && <AuditShare reportId={reportId} reportKind="opengraph" />}
      <div className="flex gap-4">
        <Button to={`/audit?${searchParams.toString()}`} variant="tertiary" className="block w-fit">
          Read complete report
        </Button>
        <Button variant="secondary" onClick={() => setSearchParams({}, {
        preventScrollReset: true
      })}>
          Try another URL
        </Button>
      </div>
    </Fragment>;
}
_s(OpengraphResult, "x1AiqExIeUsBgZdcHEW9ItMd7Rw=", false, function () {
  return [useSearchParams];
});
_c = OpengraphResult;
var _c;
$RefreshReg$(_c, "OpengraphResult");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;